import React from 'react';
import img2 from '../images/Instruction for correct pose during office work.jpg';
import img1 from '../images/8401.jpg';
import {Container, Button} from 'react-bootstrap';
export default function Section6() {
  return (
    <section id='work'>
    <div className='row justify-content-center'> 
            <Container >
                <div className='justify-content-center p-4'>
                    <h1 className='col-md-auto text-center'>
                        My Work
                    </h1>
                    <h6 className ='text-center'>
                        I have worked with top companies and also brands <br /> 
                        to make the online presence more eye-catchy and customer friendly. <br />I have 
                        done more than 100+ projects already.
                    </h6>
                </div> 
                <div className="container-fluid ">
                <div className="row justify-content-center">
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot" >
                        <img src={img2} className="img-fluid" alt=" "/> 
                    </div>
                </div>
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot ">
                        <img src={img1} className="img-fluid" alt=" "/> 
                    </div>
                </div>
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot ">
                        <img src={img2} className="img-fluid" alt=" "/>
                    </div>
                </div>
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot ">
                        <img src={img1} className="img-fluid" alt=" "/> 
                    </div>
                </div>
                </div>
                {/* <div className="row justify-content-center">
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot ">
                        <img src={img2} className="img-fluid" alt=" "/> 
                    </div>
                </div>
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot ">
                        <img src={img1} className="img-fluid" alt=" "/> 
                    </div>
                </div>
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot ">
                    <img src={img2} className="img-fluid" alt=" "/> 
                    </div>
                </div>
                <div className="col-12 col-sm-2">
                    <div className="inner__silhot ">
                    <img src={img1} className="img-fluid" alt=" "/>
                    </div>
                </div> 
                </div> */}
            </div>
            </Container> 
            <div className='p-4 text-center'>
                    <Button variant='outline-dark'>
                        View more
                    </Button> 
            </div>
    </div>
    </section>
  )
}
